import { gql } from '@apollo/client'

export const LOAD_CLUB_COURSES_QUERY = gql`
  query GetClubCourses($clubId: ID!) {
    CoursesQuery {
      clubCourses(clubId: $clubId) {
        id
        name
        description
        holesNum
        teesNum
        holes {
          id
          name
          description
          guideline
          par
          handicap
          order
          createdAt
          updatedAt
          greenDataPosition
        }
      }
    }
  }
`

export const CREATE_COURSE_MUTATION = gql`
  mutation CreateCourse($input: CreateCourseInput!) {
    CoursesMutation {
      createCourse(input: $input) {
        id
        name
        description
        holesNum
        teesNum
        holes {
          id
          name
          description
          guideline
          par
          handicap
          order
          createdAt
          updatedAt
          greenDataPosition
        }
      }
    }
  }
`

export const DELETE_COURSE_MUTATION = gql`
  mutation DeleteCourse($clubId: ID!, $courseId: ID!) {
    CoursesMutation {
      deleteCourse(clubId: $clubId, courseId: $courseId)
    }
  }
`

export const ARCHIVE_COURSE_MUTATION = gql`
  mutation ArchiveCourse($courseId: ID!) {
    CoursesMutation {
      archiveCourse(courseId: $courseId) {
        id
        archivedAt
      }
    }
  }
`

export const UNARCHIVE_COURSE_MUTATION = gql`
  mutation UnarchiveCourse($courseId: ID!) {
    CoursesMutation {
      unarchiveCourse(courseId: $courseId) {
        id
        archivedAt
      }
    }
  }
`

export const UPDATE_COURSE_MUTATION = gql`
  mutation UpdateCourse($input: UpdateCourseInput!) {
    CoursesMutation {
      updateCourse(input: $input) {
        id
        name
        description
        holesNum
        teesNum
        holes {
          id
          name
          description
          guideline
          par
          handicap
          order
          createdAt
          updatedAt
          greenDataPosition
        }
      }
    }
  }
`
